module.exports = __webpack_public_path__ + "static/media/AI_9.c7cf6905.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_9.png
// module id = 124
// module chunks = 0